<template>
  <!-- 7-5 用户医疗机构岗位添加页面进度1 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 标题部分 -->
      <div class="top-title">{{ $t("postingJobOffer") }}</div>
      <!-- 进度条部分 -->
      <div class="progress-bar">
        <div class="line-between-active"></div>
        <div class="progress-item-active">
          1 <span class="progress-title">{{$t('workContent')}}</span>
        </div>
        <div class="line-center-normal"></div>
        <div class="progress-item-normal">
          2<span class="progress-title">{{$t('salaryConditions')}}</span>
        </div>
        <div class="line-center-normal"></div>
        <div class="progress-item-normal">
          3<span class="progress-title">{{$t('confirm')}}</span>
        </div>
        <div class="line-between-normal"></div>
      </div>
      <!-- 第一行 案件名-->
      <div class="first-line-box">
        <p class="title-all-css">{{ $t("projectTitleName") }}<span>*</span></p>
        <el-input v-model="jobName"  @blur="inputData(2)" maxlength="100"></el-input>
      </div>
      <!-- 第二行 -->
      <div class="line-img-box">
        <p class="line-top-title">{{ $t("projectPhoto") }}</p>
        <!-- 第一张照片 -->
        <div class="img-list-box">
          <div
            :class="imgList.length >= 1 ? 'add-img-div' : 'add-img-div-normal '"
            @click="toGetImg"
          >
            <img
              :src="imgList.length >= 1 ? imgList[0] : normal"
              alt=""
              :class="imgList.length >= 1 ? 'img-not-normal' : 'img-normal'"
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }"
            />
            <span v-if="imgList.length < 1">{{ $t("oneSheet") }}</span>
            <div
              class="close-box"
              v-if="imgList.length >= 1"
              @click.stop="imgClose(0)"
            >
              ×
            </div>
          </div>
          <!-- 第二张照片 -->
          <div
            :class="imgList.length >= 2 ? 'add-img-div' : 'add-img-div-normal '"
            @click="toGetImg"
          >
            <img
              :src="imgList.length >= 2 ? imgList[1] : normal"
              :class="imgList.length >= 2 ? 'img-not-normal' : 'img-normal'"
              alt=""
               @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }"
            />
            <span v-if="imgList.length < 2">{{ $t("twoSheet") }}</span>
            <div
              class="close-box"
              v-if="imgList.length >= 2"
              @click.stop="imgClose(1)"
            >
              ×
            </div>
          </div>
          <!-- 第三张照片 -->
          <div
            :class="imgList.length >= 3 ? 'add-img-div' : 'add-img-div-normal '"
            @click="toGetImg"
          >
            <img
              :src="imgList.length >= 3 ? imgList[2] : normal"
              :class="imgList.length >= 3 ? 'img-not-normal' : 'img-normal'"
              alt=""
               @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }"
            />
            <span v-if="imgList.length < 3">{{ $t("threeSheet") }}</span>
            <div
              class="close-box"
              v-if="imgList.length === 3"
              @click.stop="imgClose(2)"
            >
              ×
            </div>
          </div>
        </div>
      </div>
      <!-- 第三行 -->
      <div class="line-box">
        <div class="normal-line-box">
          <p class="title-all-css">
            {{ $t("occupationCategory") }}<span>*</span>
          </p>
          <el-dropdown @command="handleCommand1">
            <span class="el-dropdown-link">
              {{ workType }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item,index) in workTypeData"
                :key="item.code"
                :command="item"
              >{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("numberOfHires") }}<span>*</span></p>
          <el-input v-model="recruitNumber" @input="inputData(4)" maxlength="20"></el-input>
        </div>
      </div>
      <!-- 第四行 -->
      <div class="line-box">
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("workLocation") }}<span>*</span></p>
          <el-input v-model="workSpace" @blur="inputData(1)" maxlength="50"></el-input>
        </div>
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("dutyTime") }}<span>*</span></p>
          <el-input v-model="workTime" @blur="inputData(5)" maxlength="100"></el-input>
        </div>
      </div>
      <!-- 第五行 -->
      <div class="line-box">
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("recruiter") }}<span>*</span></p>
            <p class="user-css">
              {{ recruiter }}
            </p>
        </div>
        <div class="normal-line-box">
          <p class="title-all-css">
            {{ $t("targetRecruitmentTime") }}<span>*</span>
          </p>
          <div class="block">
            <el-date-picker
              v-model="principalTime"
              type="date"
              @blur="dataTimeChange2"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <!-- 第六行 -->
      <div class="label-line-box">
        <div
          :class="label1 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(1)"
        >
          {{ $t("foreignersWelcome") }}<span @click.stop="labelDel(1)">×</span>
        </div>
        <div
          :class="label2 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(2)"
        >
          {{ $t("inexperiencedOK") }}<span @click.stop="labelDel(2)">×</span>
        </div>
        <div
          :class="label3 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(3)"
        >
          {{ $t("newGraduateOK") }}<span @click.stop="labelDel(3)">×</span>
        </div>
        <div
          :class="label4 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(4)"
        >
          {{ $t("educationalBackgroundMatter")
          }}<span @click.stop="labelDel(4)">×</span>
        </div>
      </div>
      <!-- 第七行 -->
      <div class="big-line-box">
        <div class="big-box-css">
          <p class="title-all-css">{{ $t("workContent") }}<span>*</span></p>
          <el-input v-model="workContent" type="textarea" @blur="inputData(3)" maxlength="255"></el-input>
        </div>
      </div>
      <!-- button 部分 -->
      <div class="line-button-box">
        <button class="button-css1" @click="saveClick">{{ $t("temporarilySaved") }}</button>
        <button class="button-css2" @click="nextClick">{{ $t("next") }}</button>
      </div>
    </div>
  </div>
</template>
<script>

import {saveJobInfo,selectMedicalInstitutionUser,selectJobDetailInfo, getUrlFromOSS,} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "medicalInstitutionJobCreation1",
  components: {},
  data() {
    return {
      jobName: "", //案件名input
      jobPhoto1:"",
      jobPhoto2:"",
      jobPhoto3:"",
      workType: "", //職種カテゴリー
      workTypeData:[],
      recruitNumber: "", //採用人数input
      workSpace: "", //勤務地input
      workTime: "", //勤務時間input
      recruiter: "", //採用担当
      userId:"",
      principalTime: "", //目標採用時期input
      label1: 0,
      label2: 0,
      label3: 0,
      label4: 0,
      workContent: "", //勤務内容input
      labelListHandle: [],
      imgList: [],
      normal: require("./assets/Image_01.svg"),
      userList:[],
      inputData1:"",

      pathsList:[],
      urlList:[],
      language:"",
      dataItem1:"",
      judgeContinue: false,
  roleName: "",
      list: [],
      normal: require("./assets/Image_01.svg"),
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem('language');
    console.log(this.language,"语言")
    this.getLanguage();

   this.jobId = this.$route.query.jobId;
    this.getJobDetails();
    this.getWorkType();
    this.getAES();
      if( JSON.stringify(this.$route.params)!=='{}'){
console.log( this.$route.params)

      this.jobName = this.$route.params.jobName;
    this.jobPhoto1 = this.$route.params.jobPhoto1;
    this.jobPhoto2 = this.$route.params.jobPhoto2;
    this.jobPhoto3 = this.$route.params.jobPhoto3;
    this.workType = this.$route.params.workType;
    this.recruitNumber = this.$route.params.recruitNumber;
    this.workSpace = this.$route.params.workSpace;
    this.workTime = this.$route.params.workTime;
    this.recruiter = this.$route.params.recruiter;
    this.userId = this.$route.params.userId;
    this.principalTime = this.$route.params.principalTime;
    this.label1 = this.$route.params.label1;
    this.label2 = this.$route.params.label2;
    this.label3 = this.$route.params.label3;
    this.label4 = this.$route.params.label4;
    this.workContent = this.$route.params.workContent;
    this.inputData1 = this.$route.params.inputData1;

    this.pathsList = this.$route.params.pathsList;
    this.urlList = this.$route.params.urlList;
    this.imgList=this.$route.params.urlList;
     }
  },
  computed: {},
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
    methods: {
          //获取求人案件详情
    getJobDetails() {
      console.log("获取案件详情" + this.jobId);
      const that = this;
      var jobId = {
        jobId: that.jobId
      };
      selectJobDetailInfo(jobId)
        .then(res => {
          console.log("--------求人信息详情查看接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            console.log("求人信息详情查看接口", res);
            const aesFecInfo1 = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo1);
            that.list = aesFecInfo1.data[0];
            that.jobName = aesFecInfo1.data[0].jobName;
            that.inputData1 = aesFecInfo1.data[0].workType;
            that.recruitNumber = aesFecInfo1.data[0].recruitNumber;
            that.workSpace = aesFecInfo1.data[0].workSpace;
            that.workTime = aesFecInfo1.data[0].workTime;
            that.recruiter = aesFecInfo1.data[0].userName;
            that.principalTime = aesFecInfo1.data[0].principalTime;
            that.label1 = parseInt(aesFecInfo1.data[0].label1);
            that.label2 = parseInt(aesFecInfo1.data[0].label2);
            that.label3 = parseInt(aesFecInfo1.data[0].label3);
            that.label4 = parseInt(aesFecInfo1.data[0].label4);
            that.workContent = aesFecInfo1.data[0].workContent;
            that.jobPhoto1 = aesFecInfo1.data[0].jobPhoto1;
            that.jobPhoto2 = aesFecInfo1.data[0].jobPhoto2;
            that.jobPhoto3 = aesFecInfo1.data[0].jobPhoto3;
            that.getUrl(that.jobPhoto1);
            that.getUrl(that.jobPhoto2);
            that.getUrl(that.jobPhoto3);
            that.pathsList.push(that.jobPhoto1);
            that.pathsList.push(that.jobPhoto2);
            that.pathsList.push(that.jobPhoto3);
            that.userId = aesFecInfo1.data[0].userId;
            that.userName = aesFecInfo1.data[0].userName;
            that.getDictText();
          }
        })
        .catch(res => {
          console.log("求人信息详情查看接口异常:", res);
        });
    },
        //获得下拉转义
    getDictText() {
      if (this.language === "CN" || this.language === "zh-CN") {
        console.log(this.list)
        this.workType = this.list.workType_dictText;
      } else {
        this.workType = this.list.jpworkType_dictText;
      }
    },
    //图片回显
    getUrl(url) {
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            // if (
            //   aesFecInfo.message ==
            //     "https://test202257.oss-cn-shanghai.aliyuncs.com/" ||
            //   aesFecInfo.message ==
            //     "https://test202257.oss-cn-shanghai.aliyuncs.com/null" ||
            //   aesFecInfo.message == ""
            // ) {
            //   this.imgList.push(require("../../assets/avatar.png"));
            //   this.urlList.push(require("../../assets/avatar.png"));
            //   return;
            // }
            this.imgList.push(aesFecInfo.message);
            this.urlList.push(aesFecInfo.message);
          }
        })
        .catch(() => {});
    },
      // input校验
      inputData(num) {
        var vc1 = /^.{1,49}$/;
        var vc2 = /^.{1,99}$/;
        var vc3 = /^.{1,254}$/;
        var vc4 = /^\d{1,19}$/;

      if (num === 1) {
        if (!vc1.test(this.workSpace)) {
          this.$message({
            message:this.$t('warningJobWorkSpace'),
            type:'warning'
          });
        }
      } else if (num === 2) {
        if (!vc2.test(this.jobName)) {
          this.$message({
            message:this.$t('warningJobName'),
            type:'warning'
          });
        }
      } else if (num === 3) {
        if (!vc3.test(this.workContent)) {
          this.$message({
            message:this.$t('warningJobWorkContent'),
            type:'warning'
          });
        }
      } else if (num === 4) {
        if (!vc4.test(this.recruitNumber)) {
          this.$message({
            message:this.$t('warningJobRecruitNumber'),
            type:'warning'
          });
        }
      } else if (num === 5) {
        if (!vc2.test(this.workTime)) {
          this.$message({
            message:this.$t('warningJobWorkTime'),
            type:'warning'
          });
        }
      }
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        that.getLanguage();
        that.getWorkType();
      }
    },
    // 获取头部信息
    getAES() {
      var userInfo = localStorage.getItem("userInfo")
      const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
      console.log("---------------userInfo---------------")
      console.log(aesFecInfo)
      this.recruiter = aesFecInfo.userName
      this.userId = aesFecInfo.userId
    },
    getLanguage(){
      if(this.language === "CN"){
        this.dataItem1 = "workType"
      }
      else {
        this.dataItem1 = "jpworkType"
      }
    },
    //工作类型下拉框
    getWorkType(){
      var that=this;
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.dataItem1
          },
          headers:{
            'content-type': 'application/x-www-form-urlencoded',
            "token":localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if(res.data.code === "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.workTypeData=aesFecInfo.data;
            console.log(that.workTypeData);
          }else{
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //工作类型下拉框
    handleCommand1(evt){
      this.inputData1=evt.code;
      this.workType=evt.name;
      console.log(evt);
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.label1 = 1;
        this.labelListLength(1);
      } else if (num === 2) {
        this.label2 = 1;
        this.labelListLength(2);
      } else if (num === 3) {
        this.label3 = 1;
        this.labelListLength(3);
      } else if (num === 4) {
        this.label4 = 1;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("外国人歓迎") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("未経験 OK") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("新卒 OK") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("学歴問わない") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("外国人歓迎");
      } else if (num === 2) {
        this.labelListHandle.push("未経験 OK");
      } else if (num === 3) {
        this.labelListHandle.push("新卒 OK");
      } else if (num === 4) {
        this.labelListHandle.push("学歴問わない");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "外国人歓迎") {
            this.labelListHandle.splice(i, 1);
            this.label1 = 0;
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "未経験 OK") {
            this.labelListHandle.splice(i, 1);
            this.label2 = 0;
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "新卒 OK") {
            this.labelListHandle.splice(i, 1);
            this.label3 = 0;
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "学歴問わない") {
            this.labelListHandle.splice(i, 1);
            this.label4 = 0;
          }
        }
      }
      console.log(this.labelListHandle);
    },
    //上传图片
    toGetImg(num) {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";
        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 2;
        const size = files.size / 1024 / 1024;
        console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error(this.$t("imageSize"));
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error(this.$t("selectImage"));
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function () {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.imgList.push(this.result);
            console.log(that.imgList, "111");
            // 数据传到后台
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            console.log(formData.get("file"));
            axios
              .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                headers: {
                  //头部参数
                  "Content-Type": "multipart/form-data",
                  token: localStorage.getItem("token")
                }
              })
              .then(function (res) {
                //请求成功
                if (res.data.code === "200 OK") {
                  console.log("-----上传图片参数-----");
                  console.log(res);
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  that.pathsList.push(aesFecInfo.path);
                  that.urlList.push(aesFecInfo.url);
                  console.log(that.pathsList)
                  console.log(that.urlList)
                  that.jobPhoto1 = that.pathsList[0];
                  that.jobPhoto2 = that.pathsList[1];
                  that.jobPhoto3 = that.pathsList[2];
                }
              })
              .catch(function (error) {
                //请求失败
                console.log(error);
              });
          };
        }
      }
    },
    //图片删除
    imgClose(num) {
      this.imgList.splice(num, 1);
      this.pathsList.splice(num, 1);
      this.urlList.splice(num, 1);
      this.jobPhoto1 = this.pathsList[0];
      this.jobPhoto2 = this.pathsList[1];
      this.jobPhoto3 = this.pathsList[2];
      console.log(this.imgList);
    },
    judgeData(){
       if(this.jobName === "" || this.workTypeData === "" || this.recruitNumber === ""
         || this.workSpace === "" || this.workTime === "" || this.recruiter === ""
         || this.principalTime === "" || this.workContent ==="") {
         this.$message({
           message: this.$t("dataEmpty"),
           type: 'warning'
         });
         this.judgeContinue = true;
       }
       else {
         this.judgeContinue = false;
       }
    },

    nextClick(){
      console.log("下一步");
      this.judgeData();
      if(this.judgeContinue === false){
        this.$router.push({
          path: '/medicalInstitutionJobCreation2',
          name: 'medicalInstitutionJobCreation2',
          params: {
            jobName: this.jobName,
            jobPhoto1: this.jobPhoto1,
            jobPhoto2: this.jobPhoto2,
            jobPhoto3: this.jobPhoto3,
            workType: this.workType,
            recruitNumber: this.recruitNumber,
            workSpace: this.workSpace,
            workTime: this.workTime,
            recruiter: this.recruiter,
            userId:this.userId,
            principalTime: this.principalTime,
            label1: this.label1,
            label2: this.label2,
            label3: this.label3,
            label4: this.label4,
            workContent: this.workContent,
            inputData1: this.inputData1,
            pathsList: this.pathsList,
            urlList: this.urlList,
          }
        });
      }
    },
    saveClick(){
      this.judgeData();
      if(this.judgeContinue === false) {
        var fakeInfo = {
          employmentConditions: "",//录用条件---2
          employmentForm1: 0,//雇佣形式1--------2
          employmentForm2: 0,//雇佣形式2--------2
          employmentForm3: 0,//雇佣形式3--------2
          employmentForm4: 0,//雇佣形式4--------2
          endSalary: 0,//结束薪资--------2
          other: "",//其他--------------------2
          startSalary: 0,//起薪--------------2
          welfareTreatment: "",//福利待遇------2
          hourSalary: 0,//期望薪资------?
          jobName: this.jobName,//事件名-----------1
          userId: this.userId,
          jobPhoto1: this.jobPhoto1,//事件照片1------1
          jobPhoto2: this.jobPhoto2,//事件照片2-------1
          jobPhoto3: this.jobPhoto3,//事件照片3--------1
          label1: this.label1,//标签1--------1
          label2: this.label2,//标签2--------1
          label3: this.label3,//标签3--------1
          label4: this.label4,//标签4--------1
          principalTime: this.principalTime,//目标录用时间------1
          recruitNumber: this.recruitNumber,//录用人数----------1
          workContent: this.workContent,//工作内容-----1
          workSpace: this.workSpace,//工作地--------1
          workTime: this.workTime,//工作时间-------1
          workType: this.inputData1//工作种类--------1
        }
        saveJobInfo(fakeInfo).then((res) => {
          console.log("求人信息添加保存1接口");
          console.log(res);
          if(res.data.code === "A0000"){
            this.$message({
              message: this.$t("saveSuccess"),
              type: 'success'
            });
            this.$router.push("/userInformationListOfMedicalInstitutionsSeekingApplicants");
          }
          else{
            this.$message.error(this.$t("saveFail"));
          }
        }).catch((res) => {
        })
      }
    },
    dataTimeChange1() {
      this.workTime = this.timeJs(this.workTime)
    },
    dataTimeChange2() {
      this.principalTime = this.timeJs(this.principalTime)
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = ' 星期' + '日一二三四五六'.charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes()
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d;
    },
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  width: 700px;
  height: 100%;
  margin: 0 auto;
  margin-bottom: 80px;
}
.top-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  margin-top: 20px;
}
.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 35px;
}
.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}
.line-between-normal {
  height: 2px;
  width: 80px;
  background: #dce3e9;
}
.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}

.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}
.line-center-active {
  width: 160px;
  height: 2px;
  background: #51abff;
}
.line-center-normal {
  width: 160px;
  height: 2px;
  background: #dce3e9;
}
.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}
.first-line-box {
  width: 640px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 30px;
  position: relative;
}
.title-all-css {
  padding: 0 5px;
  background: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  position: absolute;
  top: -12px;
  left: 10px;
  z-index: 10;
}
.title-all-css span {
  color: #da1414;
  margin-left: 2px;
}
.first-line-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0 10px;
  color: #09101d;
}
.first-line-box /deep/ .el-input {
  width: 99%;
  height: 42px;
  margin-left: 2px;
}
.line-box {
  width: 640px;
  height: 48px;
  margin: 0 auto;
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
}
.normal-line-box {
  width: 300px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.line-box /deep/ .el-dropdown {
  width: 299px;
  height: 44px;
  line-height: 44px;
  padding-left: 10px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #b2b2b2;
  box-sizing: border-box;
}
.line-box /deep/ .el-dropdown-link {
  width: 280px;
  display: inline-block;
}
.line-box /deep/ .el-icon-arrow-down {
  line-height: 44px;
  float: right;
}
.normal-line-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0 10px;
  color: #09101d;
}
.normal-line-box /deep/ .el-input {
  width: 99%;
  height: 42px;
  margin-left: 2px;
}
.label-line-box {
  width: 640px;
  height: 44px;
  margin: 0 auto;
  margin-top: 25px;
}
.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.big-line-box {
  height: 127px;
  width: 640px;
  margin: 0 auto;
  margin-top: 25px;
}
.big-box-css {
  height: 127px;
  width: 640px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.big-box-css /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 107px;
  width: 630px;
  margin-left: 2px;
  margin-top: 10px;
}
.big-box-css /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0 10px;
  color: #09101d;
}
.big-box-css /deep/ .el-input {
  width: 99%;
  height: 42px;
  margin-left: 2px;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
.line-img-box {
  width: 640px;
  margin: 0 auto;
  margin-top: 15px;
  overflow: hidden;
}
.img-list-box {
  overflow: hidden;
  display: flex;
  align-items: center;
}
.line-top-title {
  height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  padding-left: 10px;
  box-sizing: border-box;
}
.add-img-div-normal {
  padding: 0 8px;
  width: 102px;
  box-sizing: border-box;
  height: 28px;
  line-height: 28px;
  border: 1px solid #b2b2b2;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #b2b2b2;
  margin-right: 24px;
  margin-top: 5px;
  float: left;
  cursor: pointer;
  position: relative;
}
.add-img-div {
  padding: 0 8px;
  box-sizing: border-box;
  height: 70px;
  line-height: 70px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #b2b2b2;
  margin-right: 24px;
  margin-top: 5px;
  float: left;
  cursor: pointer;
  position: relative;
}
.img-normal {
  width: 18px;
  height: 16px;
}
.img-not-normal {
  width: 70px;
  height: 70px;
}
.close-box {
  position: absolute;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  line-height: 14px;
  text-align: center;
  top: -4px;
  right: 2px;
  background: #da1414;
  color: #fff;
  cursor: pointer;
}
.block /deep/ .el-icon-date:before {
  content: "";
}
.user-css{
  padding: 0 15px;
  width: 300px;
  box-sizing: border-box;
  line-height: 28px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: #b2b2b2;
  margin-top: 6px;
  float: left;
  cursor: pointer;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitutionJobCreation1/index.vue